import { createContext } from "react";

// Create Context
export const AnimationContext = createContext();
